/**
 * Normalizes text for use in URL slugs.
 * Converts to lowercase and replaces whitespace, slashes, and common punctuation with hyphens.
 */
export function normalizeSlug(text: string): string {
  return text.toLowerCase().replace(/[\s/&.,+-]+/g, '-')
}
